import { useContext, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Button, Card, CardActions, CardContent, CardHeader, type Theme } from '@mui/material';
import { Input, RoutePaths } from '@shared';
import { DelayedLinearProgress, RouterLink, SnackbarContext } from '@widgets';

const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    padding: theme.spacing(0, 0.5, 2, 0.5),
  },
  cardActions: {
    justifyContent: 'space-between',
  },
  cardHeader: {
    background: 'none',
    textAlign: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: 0,
  },
  cardHeaderTitle: {
    color: theme.palette.primary.main,
  },
}));

const loading = false;

export const LoginPage = () => {
  const [showError, setShowError] = useState<boolean>(false);

  const classes = useStyles();
  const snackbar = useContext(SnackbarContext);

  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get('error');

  useEffect(() => {
    if (!error || showError) return;

    setShowError(true);
    snackbar.error(error);
  }, [error, showError]);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const {
      userId: { value: userId },
      applicationName: { value: applicationName },
    } = e.currentTarget;

    if (!userId || !applicationName) return;

    window.location.href = `${window.location.href}?userId=${userId}`;
  };

  return (
    <Card className={classes.card}>
      <form onSubmit={onSubmit}>
        <CardHeader
          className={classes.cardHeader}
          title='Sign in'
          subheader='Use your Insinet account'
          classes={{ title: classes.cardHeaderTitle }}
        />
        <CardContent>
          <Input label='User Id' name='userId' autoComplete='userId' required />
          <Input label='Application Name' name='applicationName' required />
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button type='button' size='medium' disabled={loading} component={RouterLink} to={RoutePaths.forgotPassword.onNavigate()}>
            Forgot password
          </Button>
          <Button type='submit' size='medium' color='primary' variant='contained' disabled={loading}>
            Login
          </Button>
        </CardActions>
        <DelayedLinearProgress variant='query' loading={loading} />
      </form>
    </Card>
  );
};
